import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Column from '@amzn/meridian/column';
import { useBundle } from '@amzn/react-arb-tools';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { DogPage } from 'src/common/errors';
import { Loading } from 'src/common/loaders/Loading';
import { useAnalyticsContext } from 'src/common/metrics';
import { useBagStore } from 'src/store';
import { usePaymentStore } from 'src/store/paymentStore';
import { PrimeButton, YellowButton } from '../../common/buttons';
import { usePaymentSelection } from '../../hooks';
import { EmptyPaymentSelectionBody } from './components/EmptyPaymentSelectionBody';
import { PaymentMethod } from './components/PaymentMethod';
import { PaymentSelectionHeader } from './components/PaymentSelectionHeader';
import { useAlert } from 'src/common/alert/AlertContext';
export const PaymentSelectionPage = () => {
    var _a, _b;
    const [bundle, isBundleLoading] = useBundle('pages.paymentSelectionPage');
    const rumClient = useAnalyticsContext();
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState('');
    const { setPaymentMethodId } = usePaymentStore();
    const { listBag } = useBagStore();
    const bagContents = listBag();
    const isPrime = (_b = (_a = bagContents[0]) === null || _a === void 0 ? void 0 : _a.isPrime) !== null && _b !== void 0 ? _b : false;
    const navigate = useNavigate();
    const { clearAlert } = useAlert();
    const { data: filteredPaymentMethods, isLoading, isError, error, refetch, isFetching } = usePaymentSelection();
    const Button = isPrime ? PrimeButton : YellowButton;
    useEffect(() => {
        if (isFetching) {
            clearAlert();
        }
    }, [isFetching]);
    if (isBundleLoading || isLoading || isFetching) {
        return _jsx(Loading, {});
    }
    if (isError) {
        rumClient.recordEvent('PAYMENT_METHODS_FETCH_ERROR', {
            errorTitle: error === null || error === void 0 ? void 0 : error.title,
            errorDetails: error === null || error === void 0 ? void 0 : error.detail,
        });
        // TODO: Implement graceful error handling for this page.
        return _jsx(DogPage, {});
    }
    const handleContinue = () => {
        if (selectedPaymentMethodId) {
            setPaymentMethodId(selectedPaymentMethodId);
            navigate(`/checkout/preview${location.search}`);
        }
    };
    return (_jsxs(Column, { spacing: "200", spacingInset: "none none 600 none", "data-testid": "payment-selection-page", children: [_jsx(PaymentSelectionHeader, {}), (filteredPaymentMethods === null || filteredPaymentMethods === void 0 ? void 0 : filteredPaymentMethods.length) ? (_jsxs(_Fragment, { children: [_jsx(Column, { spacingInset: "200 350", children: _jsx(Button, { disabled: !selectedPaymentMethodId, onClick: handleContinue, "data-testid": "continue-button", children: bundle.getMessage('continue') }) }), _jsx(Column, { spacingInset: "350 350", spacing: "none", children: filteredPaymentMethods.map((paymentMethod, index) => (_jsx(PaymentMethod, { paymentMethod: paymentMethod, isSelected: paymentMethod.paymentMethodId === selectedPaymentMethodId, onSelect: () => setSelectedPaymentMethodId(paymentMethod.paymentMethodId) }, index))) })] })) : (_jsx(EmptyPaymentSelectionBody, { refetch: refetch }))] }));
};
